import { useState } from 'react';

import { authModel } from '@_entities/auth';

import { RightChevronIcon, SelectCheckedIcon } from '@_shared/icons';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './ReferralSlide.style';

const referralList: {
	code: authModel.TTrafficSource | '';
	name: string;
}[] = [
	{
		code: 'TFCSRC01',
		name: '지인 추천',
	},
	{
		code: 'TFCSRC02',
		name: '인스타그랩/페이스북',
	},
	{
		code: 'TFCSRC03',
		name: '스레드',
	},
	{
		code: 'TFCSRC04',
		name: '앱스토어/플레이스토어 검색',
	},
	{
		code: 'TFCSRC05',
		name: '뉴스/포털 검색',
	},
	{
		code: 'TFCSRC06',
		name: '기타 커뮤니티',
	},
];

export function ReferralSlide({
	onNext,
	postReferral,
	nickname,
}: {
	onNext: () => void;
	postReferral: (referral: authModel.TTrafficSource | '', details: string) => void;
	nickname: string;
}) {
	const [referral, setReferral] = useState<authModel.TTrafficSource | ''>('');
	const [details, setDetails] = useState<string>('');

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					{nickname}
					님
					<br />
					어디서 딸깍을 알게 되셨나요?
				</Typography>
			</S.TermsSlide>

			<S.ReferalList>
				{referralList.map((referralItem) => (
					<S.ReferalItem
						key={referralItem.code}
						onClick={() =>
							setReferral((prev) =>
								prev === referralItem.code ? '' : referralItem.code,
							)
						}
						isActive={referral === referralItem.code}
					>
						<S.ReferalItemRow isActive={referral === referralItem.code}>
							<Typography type="title-medium" color="warmgray-800">
								{referralItem.name}
							</Typography>
							<SelectCheckedIcon />
						</S.ReferalItemRow>
						{referralItem.code === 'TFCSRC06' && referral === referralItem.code && (
							<S.ReferralInput
								onClick={(e) => e.stopPropagation()}
								placeholder="예) 카카오톡 오픈채팅방, 네이버 카페"
								type="text"
								maxLength={30}
								onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
									setDetails(e.currentTarget.value);
								}}
							/>
						)}
					</S.ReferalItem>
				))}
			</S.ReferalList>

			<S.BottomButtonContainer>
				<Button
					bgColor={referral ? 'orange-primary' : 'warmgray-300'}
					fullWidth
					disabled={!referral}
					onClick={() => {
						postReferral(referral, details);
						onNext();
					}}
				>
					<Typography type="title-large" color="white-primary">
						다음
					</Typography>
				</Button>
				<S.SkipText
					onClick={() => {
						postReferral('', '');
						onNext();
					}}
				>
					<Typography type="label-large">건너뛰기</Typography>
					<RightChevronIcon />
				</S.SkipText>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
